import { Button, ButtonLoaderPlacement, ButtonSize, ButtonVariant } from '@farmasiet/frontendcore-reactcomponents';
import classNames from 'classnames';
import * as React from 'react';

import { PurchaseConfirmationForm } from '../../../../../../../Common/Pim/Enums/PurchaseConfirmationForm.csharp';
import { getTranslation, keys } from '../../../../../../../Resources/Translations';
import { NavigationTrackerButtonLink } from '../../../../../../ReactComponents/NavigationTracker/NavigationTrackerButtonLink';
import { AddToCartMode } from '../../ViewModel/AddToCartMode.csharp';
import { AddToCartViewModel } from '../../ViewModel/AddToCartViewModel.csharp';

interface AddToCartButtonProps {
    model: AddToCartViewModel;
    isLoading: boolean;
    isProductPage: boolean;
    prescriptionUrl: string;
    displaySucceededMessage: boolean;
}

export const AddToCartButton = ({
    model: { mode, formConfiguration, isOnPrescription },
    isLoading,
    isProductPage,
    prescriptionUrl,
    displaySucceededMessage
}: AddToCartButtonProps) => {
    const buttonContent = () => {
        if (displaySucceededMessage) {
            return (
                <div className="AddToCartButton--WithIcon">
                    {getTranslation(keys['addToCart.successfullyAdded'])}
                    <span className="AddToCart__Succeeded" />
                </div>
            );
        }

        return formConfiguration?.type !== PurchaseConfirmationForm.Unknown && isProductPage ? (
            <span>{getTranslation(keys['addToCart.buyWithGuidance'])}</span>
        ) : (
            <span>{getTranslation(keys['addToCart.buy'])}</span>
        );
    };

    const size = isProductPage ? ButtonSize.Large : ButtonSize.XSmall;
    const variant = isProductPage ? ButtonVariant.Primary : ButtonVariant.Secondary;
    const disabled = !isProductPage && isLoading;
    const loading = isProductPage && isLoading;
    const placement = isProductPage ? ButtonLoaderPlacement.Left : ButtonLoaderPlacement.Right;
    const className = classNames('AddToCartButton', isProductPage && 'AddToCartButton--Big', displaySucceededMessage && 'AddToCartButton--InvertedColors');

    if (mode === AddToCartMode.Default) {
        return (
            <Button size={size} variant={variant} disabled={disabled} loading={loading} type="submit" className={className} loaderPlacement={placement}>
                {buttonContent()}
            </Button>
        );
    }

    if (mode === AddToCartMode.Prescription && prescriptionUrl) {
        return (
            <NavigationTrackerButtonLink
                variant={variant}
                size={size}
                href={prescriptionUrl}
                target="_blank"
                rel="nofollow noopener noreferrer"
                className={className}
                source={isProductPage ? 'ProductPage' : 'ProductCard'}
            >
                {isProductPage ? (
                    <span>{getTranslation(keys['product.myPrescriptions'])}</span>
                ) : (
                    <span>{getTranslation(keys['productCard.prescription'])}</span>
                )}
            </NavigationTrackerButtonLink>
        );
    }

    return (
        <Button size={size} variant={variant} className={className} disabled>
            {isOnPrescription ? (
                isProductPage ? (
                    <span>{getTranslation(keys['product.myPrescriptions'])}</span>
                ) : (
                    <span>{getTranslation(keys['productCard.prescription'])}</span>
                )
            ) : (
                <span>{getTranslation(keys['addToCart.buy'])}</span>
            )}
        </Button>
    );
};
